import parsePhoneNumberFromString, { getCountryCallingCode } from 'libphonenumber-js';
import React, { useState, useEffect } from 'react';

function getNavigator() {
    return navigator;
}
function getIntl() {
    return Intl;
}
function getFetch() {
    return fetch;
}

var countryExceptions = {
    'es-419': 'es-MX',
    'fr': 'fr-FR',
};
function locale$1() {
    var language = getNavigator().language;
    language = countryExceptions[language] || language;
    return language.length === 5 ? language.slice(0, 3) + language.slice(3, 5).toLocaleUpperCase() : language;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function toLocaleCurrency(number, currencyCode, options) {
    if (options === void 0) { options = {}; }
    return getIntl().NumberFormat(locale$1(), __assign({ style: 'currency', currency: currencyCode }, options)).format(number);
}

//type Options = Intl.DateTimeFormatOptions; <- TypeScript 3.x have a issue with option types
function toLocaleDateTime(date, options) {
    if (options === void 0) { options = {}; }
    // will fallback to US datetime if supplied locale isn't valid
    return getIntl().DateTimeFormat([locale$1(), 'en-US'], options).format(date);
}

function toLocaleNumber(number, options) {
    if (options === void 0) { options = {}; }
    if (!number && number !== 0)
        return '';
    return getIntl().NumberFormat(locale$1(), options).format(number);
}

var countryFormats = {
    "US": {
        long: ["[address1]", "[address2]", "[city], [state] [postalcode]", "[country]"],
        short: ["[address1]", "[city], [state] [postalcode]"],
    },
    "CA": {
        long: ["[address1]", "[address2]", "[state] ([city]) [postalcode]", "[country]"],
        short: ["[address1]", "[state] ([city]) [postalcode]"],
    },
    "MX": {
        long: ["[address1]", "[address2]", "[postalcode] [city], [state]", "[country]"],
        short: ["[address1]", "[postalcode] [city], [state]"],
    },
    "BR": {
        long: ["[address1]", "[address2]", "[city], [state] [postalcode]", "[country]"],
        short: ["[address1]", "[city], [state] [postalcode]"],
    },
    "DE": {
        long: ["[address1]", "[address2]", "[postalcode] [city]", "[country]"],
        short: ["[address1]", "[postalcode] [city]"],
    },
    "IT": {
        long: ["[address1]", "[address2]", "[postalcode] [city] [state]", "[country]"],
        short: ["[address1]", "[postalcode] [city] [state]"],
    },
    "NL": {
        long: ["[address1]", "[address2]", "[postalcode] [city]", "[country]"],
        short: ["[address1]", "[postalcode] [city]"],
    },
    "PL": {
        long: ["[address1]", "[address2]", "[postalcode] [city]", "[country]"],
        short: ["[address1]", "[postalcode] [city]"],
    },
    "CN": {
        long: ["[country], [postalcode]", "[state], [city]", "[address1]", "[address2]"],
        short: ["[postalcode]", "[state], [city]", "[address1]"],
    },
    "JP": {
        long: ["[country]", "[city], [state] [postalcode]", "[address1]", "[address2]"],
        short: ["[city], [state] [postalcode], [address1], [address2]"],
    },
    "KO": {
        long: ["[country]", "[city], [state] [postalcode]", "[address1]", "[address2]"],
        short: ["[city], [state] [postalcode]", "[address1]"],
    },
};
var regionFormats = {
    "North_America": {
        long: ["[address1]", "[address2]", "[city], [state] [postalcode]", "[country]"],
        short: ["[address1]", "[city], [state] [postalcode]"],
    },
    "South_America": {
        long: ["[address1]", "[address2]", "[city], [state] [postalcode]", "[country]"],
        short: ["[address1]", "[city], [state] [postalcode]"],
    },
    "Europe": {
        long: ["[address1]", "[address2]", "[postalcode] [city] [state]", "[country]"],
        short: ["[address1]", "[postalcode] [city] [state]"],
    },
    "Asia": {
        long: ["[country]", "[city], [state] [postalcode]", "[address1]", "[address2]"],
        short: ["[city], [state] [postalcode]", "[address1]"],
    },
    "Oceania": {
        long: ["[address1]", "[address2]", "[city], [postalcode]", "[country]"],
        short: ["[address1]", "[city], [postalcode]"],
    },
    "Africa": {
        long: ["[address1]", "[address2]", "[city], [state] [postalcode]", "[country]"],
        short: ["[address1]", "[city], [state] [postalcode]"],
    },
};

var regionCountries = {
    "North_America": ['US', 'CA', 'MX'],
    "South_America": ['AR', 'BR', 'CL', 'CO', 'EC', 'GY', 'PE', 'SR', 'UY', 'VE'],
    "Europe": ['AL', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'MC', 'NL', 'NO', 'PL', 'PT', 'RO', 'RU', 'SM', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'UA', 'GB'],
    "Asia": ['AF', 'AM', 'AZ', 'BH', 'BD', 'BT', 'BN', 'KH', 'CN', 'CY', 'GE', 'IN', 'ID', 'IR', 'IQ', 'IL', 'JP', 'JO', 'KZ', 'KP', 'KR', 'KW', 'KG', 'LA', 'LB', 'MY', 'MV', 'MN', 'MM', 'NP', 'OM', 'PK', 'PH', 'QA', 'SA', 'SG', 'LK', 'SY', 'TW', 'TJ', 'TH', 'TR', 'TM', 'AE', 'UZ', 'VN', 'YE', 'HK'],
    "Africa": ['DZ', 'AO', 'BJ', 'BW', 'BF', 'BI', 'CM', 'CV', 'CF', 'TD', 'KM', 'CD', 'CG', 'CI', 'DJ', 'EG', 'GQ', 'ER', 'ET', 'GA', 'GM', 'GH', 'GN', 'GW', 'KE', 'LS', 'LR', 'LY', 'MG', 'MW', 'ML', 'MR', 'MU', 'YT', 'MA', 'MZ', 'NA', 'NE', 'NG', 'RW', 'ST', 'SN', 'SC', 'SL', 'SO', 'ZA', 'SS', 'SD', 'SZ', 'TZ', 'TG', 'TN', 'UG', 'EH', 'ZM', 'ZW'],
    "Oceania": ['AU', 'FJ', 'KI', 'MH', 'FM', 'NR', 'NZ', 'PW', 'PG', 'WS', 'SB', 'TO', 'TV', 'VU']
};
function regionByCountry(country) {
    var regionCountry = 'North_America';
    for (var _i = 0, _a = Object.entries(regionCountries); _i < _a.length; _i++) {
        var _b = _a[_i], region = _b[0], countries = _b[1];
        if (countries.includes(country)) {
            regionCountry = region;
        }
    }
    return regionCountry;
}

function toLocaleAddress(addressLine1, addressLine2, postalCode, city, state, country, format, separator) {
    if (!country)
        country = "US";
    if (!format)
        format = "long";
    if (!separator)
        separator = "<br />";
    var countryData = countryFormats[country] || regionFormats[regionByCountry(country)];
    var formatData = countryData[format];
    var replacementMap = {
        "[address1]": addressLine1 || "",
        "[address2]": addressLine2 || "",
        "[postalcode]": postalCode || "",
        "[city]": city || "",
        "[state]": state || "",
        "[country]": country || ""
    };
    return formatData.map(function (line) { return line.replace(/\[[^[]+\]/g, function (match) { return replacementMap[match] || ""; }); }).filter(function (line) { return line.trim() !== ""; }).join(separator);
}

function getCallingCode(countryCode) {
    var callingCode;
    try {
        callingCode = getCountryCallingCode(countryCode);
    }
    catch (error) {
        callingCode = '1';
    }
    return callingCode;
}
function toLocalePhoneNumber(phoneNumber, dialingCode) {
    var formatedPhoneNumber = '';
    var countryString = locale$1().match(/-(\w+)/);
    var countryCode = countryString ? countryString[1] : locale$1().toLocaleUpperCase();
    var countryDailingCode = getCallingCode(countryCode);
    if (phoneNumber) {
        formatedPhoneNumber = (phoneNumber.indexOf("+" + dialingCode) === -1 && dialingCode !== undefined) ? "+" + dialingCode + " " + phoneNumber : phoneNumber;
        var phoneObject = parsePhoneNumberFromString(formatedPhoneNumber, countryCode);
        if (phoneObject && phoneObject.isValid()) {
            formatedPhoneNumber = countryDailingCode === dialingCode ? phoneObject.formatNational() : phoneObject.formatInternational();
        }
        else {
            var cleaned = phoneNumber.replace(/\D/g, '');
            var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
            var exceptionFormat = countryDailingCode !== dialingCode && dialingCode !== undefined ? "+" + dialingCode + " " : '';
            if (match) {
                return [exceptionFormat, '(', match[2], ') ', match[3], '-', match[4]].join('');
            }
            formatedPhoneNumber = phoneNumber;
        }
    }
    return formatedPhoneNumber;
}

function getLocaleNumberSeparator() {
    var _a, _b;
    var parts = locale$1() && getIntl()
        ? getIntl().NumberFormat(locale$1()).formatToParts(12345.6)
        : new Intl.NumberFormat("en-US").formatToParts(12345.6);
    var group = (_a = parts.find(function (d) { return d.type === "group"; })) === null || _a === void 0 ? void 0 : _a.value;
    var decimal = (_b = parts.find(function (d) { return d.type === "decimal"; })) === null || _b === void 0 ? void 0 : _b.value;
    return { group: group, decimal: decimal };
}

var OnlineTranslationContext$1 = React.createContext({});

var languageSourceDictionary$1 = {};
var micrositeLanguageDictionaryName = 'microsite';
var languageSourceDictionaryPromise = {};
// We could expose this in the future if we want the ability to allow loading from multiple remote sources.
// Currently we only do this for microsites. Others use "addLanguageDictionary".
function loadRemoteLanguageDictionary(dictionaryName, baseUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var languageKey, promise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!languageSourceDictionaryPromise[dictionaryName]) return [3 /*break*/, 2];
                    return [4 /*yield*/, languageSourceDictionaryPromise[dictionaryName]];
                case 1:
                    _a.sent();
                    return [2 /*return*/, loadedLanguages()];
                case 2:
                    languageKey = locale$1();
                    // Language is already loaded
                    if (languageSourceDictionary$1[languageKey]) {
                        return [2 /*return*/, loadedLanguages()];
                    }
                    promise = new Promise(function (resolve) {
                        return __awaiter(this, void 0, void 0, function () {
                            var headers, response, languageDictionary, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        headers = new Headers();
                                        headers.append('Cache-Control', 'public, max-age=43200'); // 43,200 = 12 hours
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 4, , 5]);
                                        return [4 /*yield*/, getFetch()(baseUrl + "/" + languageKey + ".json", { cache: 'default', headers: headers })];
                                    case 2:
                                        response = _a.sent();
                                        return [4 /*yield*/, response.json()];
                                    case 3:
                                        languageDictionary = _a.sent();
                                        if (languageDictionary) {
                                            languageSourceDictionary$1[dictionaryName] = languageDictionary;
                                        }
                                        return [3 /*break*/, 5];
                                    case 4:
                                        error_1 = _a.sent();
                                        console.error("Failed to load \"" + dictionaryName + "\" language file", error_1);
                                        return [3 /*break*/, 5];
                                    case 5:
                                        resolve(languageSourceDictionary$1);
                                        return [2 /*return*/];
                                }
                            });
                        });
                    });
                    languageSourceDictionaryPromise[dictionaryName] = promise;
                    return [2 /*return*/, promise];
            }
        });
    });
}
function addLanguageDictionary(dictionaryName, languageDictionary) {
    languageSourceDictionary$1[dictionaryName] = languageDictionary;
    return languageSourceDictionary$1;
}
function loadMicrositeLanguage$1() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, loadRemoteLanguageDictionary(micrositeLanguageDictionaryName, './lang')];
        });
    });
}
function loadedLanguages() {
    return __assign({}, languageSourceDictionary$1);
}

var replaceTokens = function (resource, replacements) {
    if (resource === void 0) { resource = ''; }
    if (replacements === void 0) { replacements = []; }
    var outputString = resource;
    if (replacements.length) {
        replacements.forEach(function (arg, index) {
            var reg = new RegExp("(\\{" + index + "\\})", "g");
            outputString = outputString.replace(reg, function () { return arg.toString(); });
        });
    }
    return outputString;
};

function OnlineTranslationProvider$1(_a) {
    var _this = this;
    var children = _a.children, loader = _a.loader;
    var _b = React.useState(loadedLanguages()), languageSourceDictionary = _b[0], setLanguageSourceDictionary = _b[1];
    React.useEffect(function () {
        if (loader && !languageSourceDictionary[micrositeLanguageDictionaryName]) {
            (function () { return __awaiter(_this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = setLanguageSourceDictionary;
                            return [4 /*yield*/, loader(locale$1())];
                        case 1:
                            _a.apply(void 0, [_b.sent()]);
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [loader]);
    function addTranslationDictionary(dictionaryName, loader) {
        return __awaiter(this, void 0, void 0, function () {
            var newTranslationDictionary, allLanguageDictionaries, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, loader(locale$1())];
                    case 1:
                        newTranslationDictionary = _a.sent();
                        allLanguageDictionaries = addLanguageDictionary(dictionaryName, newTranslationDictionary);
                        setLanguageSourceDictionary(allLanguageDictionaries);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error("Failed to load \"" + dictionaryName + "\" language file", e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    var createTranslator = function (dictionaryName) {
        if (dictionaryName === void 0) { dictionaryName = micrositeLanguageDictionaryName; }
        return function (resourceKey, replacements) {
            if (replacements === void 0) { replacements = []; }
            if (!languageSourceDictionary[dictionaryName]) {
                return replaceTokens(resourceKey, replacements);
            }
            // Does the dictionary have the language we want?
            if (languageSourceDictionary[dictionaryName]) {
                // If it does, load it up
                var resource = languageSourceDictionary[dictionaryName][resourceKey];
                // Does that dictionary have the resource for the given key?
                if (resource) {
                    // If yes, return it
                    return replaceTokens(resource, replacements);
                }
            }
            return replaceTokens(resourceKey, replacements);
        };
    };
    return (React.createElement(OnlineTranslationContext$1.Provider, { value: { languageSourceDictionary: languageSourceDictionary, addTranslationDictionary: addTranslationDictionary, createTranslator: createTranslator, translate: createTranslator() } }, children));
}

var noTranslation = function (resourceKey) { return resourceKey; };
var useTranslation$1 = function (dictionaryName) {
    if (dictionaryName === void 0) { dictionaryName = micrositeLanguageDictionaryName; }
    var context = React.useContext(OnlineTranslationContext$1);
    // We have to use an obj here because if we just supply a function React treats it like an initializer
    // rather than a value. It appears that the same thing happens when calling the setter, but I haven't been
    // able to verify that. I've just seen the curried function within createTranslator get passed undefined params.
    var _a = useState({ translator: noTranslation }), func = _a[0], setFunc = _a[1];
    var dictName = useState(dictionaryName)[0];
    if (!context) {
        throw ("TranslationProvider needs to be a parent in order to leverage useTranslation.");
    }
    useEffect(function () {
        setFunc({ translator: context.createTranslator(dictName) });
        // don't use context.createTranslator as a param since it is recreated on each render of the context
    }, [dictName, context.languageSourceDictionary]);
    return func.translator;
};

var Translation$1 = function (props) {
    var translate = useTranslation$1(props.dictionaryName);
    return (React.createElement(React.Fragment, null, translate(props.resourceKey, props.replaceVariable)));
};
function createDictionaryTranslator(dictionaryName) {
    return function (props) {
        return React.createElement(Translation$1, { resourceKey: props.resourceKey, replaceVariable: props.replaceVariable, dictionaryName: dictionaryName });
    };
}

var useDictionary$1 = function (dictionaryName) {
    var context = React.useContext(OnlineTranslationContext$1);
    if (!context) {
        throw ("TranslationProvider needs to be a parent in order to leverage useDictionary.");
    }
    return React.useCallback(function (loader) {
        return context.addTranslationDictionary(dictionaryName, loader);
    }, []);
};

var languageSourceDictionary = {
    microsite: {
        test: "test",
    },
};
var addTranslationDictionaryTemp = function (dictionaryName, loader) {
    // This is intentional fo initialize the mock function without Jest.fn()
};
var createTranslatorTemp = function (dictionaryName) {
    return function (resourceKey, replaceVariable) {
        return replaceTokens(resourceKey, replaceVariable);
    };
};
var localeTemp = function () {
    // This is intentional fo initialize the mock function without Jest.fn()
};
var loadMicrositeLanguageTemp = function () {
    // This is intentional fo initialize the mock function without Jest.fn()
};
// Validation added to not required Jest on rollup build in UI that use this library
if (typeof jest !== "undefined") {
    addTranslationDictionaryTemp = jest.fn();
    localeTemp = jest.fn().mockReturnValue(navigator.language);
    loadMicrositeLanguageTemp = jest.fn();
}
var addTranslationDictionary = addTranslationDictionaryTemp;
var createTranslator = createTranslatorTemp;
var locale = localeTemp;
var loadMicrositeLanguage = loadMicrositeLanguageTemp;
var useTranslation = createTranslator;
var useDictionary = addTranslationDictionary;
var Translation = function (_a) {
    var resourceKey = _a.resourceKey, replaceVariable = _a.replaceVariable;
    return React.createElement(React.Fragment, null, replaceTokens(resourceKey, replaceVariable));
};
var OnlineTranslationContext = React.createContext({
    languageSourceDictionary: languageSourceDictionary,
    addTranslationDictionary: addTranslationDictionary,
    createTranslator: createTranslator,
    translate: createTranslator(),
});
var OnlineTranslationProvider = function (_a) {
    var children = _a.children;
    return (React.createElement(OnlineTranslationContext.Provider, { value: {
            languageSourceDictionary: languageSourceDictionary,
            addTranslationDictionary: addTranslationDictionary,
            createTranslator: createTranslator,
            translate: createTranslator(),
        } }, children));
};

export { OnlineTranslationContext$1 as OnlineTranslationContext, OnlineTranslationContext as OnlineTranslationContextMock, OnlineTranslationProvider$1 as OnlineTranslationProvider, OnlineTranslationProvider as OnlineTranslationProviderMock, Translation$1 as Translation, Translation as TranslationMock, createDictionaryTranslator, getLocaleNumberSeparator, loadMicrositeLanguage$1 as loadMicrositeLanguage, loadMicrositeLanguage as loadMicrositeLanguageMock, locale$1 as locale, locale as localeMock, toLocaleAddress, toLocaleCurrency, toLocaleDateTime, toLocaleNumber, toLocalePhoneNumber, useDictionary$1 as useDictionary, useDictionary as useDictionaryMock, useTranslation$1 as useTranslation, useTranslation as useTranslationMock };
//# sourceMappingURL=index.es.js.map
